import { render, staticRenderFns } from "./DeleteRecord.vue?vue&type=template&id=41bb3e43&scoped=true"
import script from "./DeleteRecord.vue?vue&type=script&lang=js"
export * from "./DeleteRecord.vue?vue&type=script&lang=js"
import style0 from "./DeleteRecord.vue?vue&type=style&index=0&id=41bb3e43&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bb3e43",
  null
  
)

export default component.exports